import { combineReducers } from 'redux';
import { authReducer } from './Reducer';
import { notificationReducer } from './NotificationReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  notification: notificationReducer

  // Add other reducers here
});

export default rootReducer;